if (!customElements.get('jjc-catalog-search')) {
  class JJCCatalogSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-release-filter]');
      this.clear = this.querySelector('[data-release-filter-clear]');
      this.status = this.querySelector('[data-release-filter-status]');
      this.catalog = this.nextElementSibling?.matches('[data-release-catalog]')
        ? this.nextElementSibling
        : this.parentElement.querySelector('[data-release-catalog]');
      this.cards = Array.from(this.catalog?.querySelectorAll('[data-release-card]') || []);
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.modal = this.section?.querySelector('[data-release-modal]');
      this.modalTitle = this.modal?.querySelector('[data-release-modal-title]');
      this.modalArt = this.modal?.querySelector('[data-release-modal-art]');
      this.modalStatus = this.modal?.querySelector('[data-release-modal-status]');
      this.modalTracks = this.modal?.querySelector('[data-release-modal-tracks]');

      this.input?.addEventListener('input', () => this.filter(this.input.value));
      this.clear?.addEventListener('click', () => {
        this.input.value = '';
        this.filter('');
        this.input.focus();
      });
      this.cards.forEach((card) => {
        card.querySelector('[data-release-details]')?.addEventListener('click', () => this.openRelease(card));
      });
      this.modal?.querySelectorAll('[data-release-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeModal());
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal && !this.modal.hidden) this.closeModal();
      });
    }

    filter(rawQuery) {
      const query = String(rawQuery || '').trim().toLowerCase();
      let count = 0;
      this.cards.forEach((card) => {
        const visible = !query || (card.dataset.searchText || card.textContent).toLowerCase().includes(query);
        card.hidden = !visible;
        if (visible) count += 1;
      });
      this.clear.hidden = !query;
      this.status.textContent = query
        ? `${count} ${count === 1 ? 'release' : 'releases'} found`
        : '';
    }

    async openRelease(card) {
      if (!this.modal) return;
      const slug = card.dataset.releaseSlug;
      const title = card.querySelector('h3')?.textContent.trim() || 'Release';
      const cardArt = card.querySelector('.jjc-card__media img');
      this.modalTitle.textContent = title;
      this.modalArt.src = cardArt?.currentSrc || cardArt?.src || '';
      this.modalArt.alt = `${title} cover art`;
      this.modalTracks.replaceChildren();
      this.modalStatus.textContent = 'Loading tracks…';
      this.modal.hidden = false;
      requestAnimationFrame(() => this.modal.classList.add('is-open'));
      this.modal.querySelector('[data-release-modal-close]:not(.jjc-release-modal__backdrop)')?.focus();

      try {
        const release = await this.findRelease(slug);
        const tracks = this.readTracks(release);
        this.modalStatus.textContent = tracks.length ? `${tracks.length} ${tracks.length === 1 ? 'track' : 'tracks'}` : 'Track list coming soon.';
        tracks.forEach((track, index) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `/?release=${encodeURIComponent(slug)}&track=${index + 1}&autoplay=1#music`;
          link.innerHTML = `<span>${String(index + 1).padStart(2, '0')}</span><strong>${this.escapeHtml(track.title)}</strong>${track.explicit ? '<small aria-label="Explicit">E</small>' : ''}`;
          item.append(link);
          this.modalTracks.append(item);
        });
      } catch (_error) {
        this.modalStatus.textContent = 'The track list could not be loaded. Use Play release to open it in the player.';
      }
    }

    closeModal() {
      if (!this.modal || this.modal.hidden) return;
      this.modal.classList.remove('is-open');
      window.setTimeout(() => { this.modal.hidden = true; }, 180);
    }

    async findRelease(slug) {
      if (!this.releaseDocumentPromise) {
        this.releaseDocumentPromise = fetch('/').then((response) => {
          if (!response.ok) throw new Error('Catalog unavailable');
          return response.text();
        }).then((html) => new DOMParser().parseFromString(html, 'text/html'));
      }
      const documentCopy = await this.releaseDocumentPromise;
      return Array.from(documentCopy.querySelectorAll('[data-jjc-release]')).find((release) => this.slugify(release.dataset.title) === slug);
    }

    readTracks(release) {
      if (!release) return [];
      const trackBlocks = Array.from(release.querySelectorAll('[data-jjc-track]'))
        .filter((track) => Boolean(track.dataset.audioUrl));
      if (trackBlocks.length) {
        return trackBlocks.map((track) => ({
          title: this.cleanTitle(track.dataset.title || 'Untitled track'),
          explicit: track.dataset.explicit === 'true'
        }));
      }
      const bulk = release.querySelector('textarea[data-bulk-tracks]')?.value || '';
      return bulk.split(/\r?\n/).map((line) => line.trim()).filter(Boolean).map((line) => {
        const parts = line.split(',');
        const marker = (parts.at(-1) || '').trim().toLowerCase();
        const explicit = /^(explicit|e)$/.test(marker) || /(?:🅴|\[explicit\])/i.test(parts[0] || '');
        return { title: this.cleanTitle(parts[0] || 'Untitled track'), explicit };
      });
    }

    cleanTitle(title) {
      return String(title).replace(/\s*(?:🅴|\[explicit\])\s*/gi, ' ').trim();
    }

    slugify(value) {
      return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    escapeHtml(value) {
      const node = document.createElement('span');
      node.textContent = value;
      return node.innerHTML;
    }
  }

  customElements.define('jjc-catalog-search', JJCCatalogSearch);
}
